import type { SVGProps } from "react";
const SvgStudyLamp = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeWidth={1.5}
      d="m17.562 9.222-.526.928c-.495.873-.743 1.309-1.282 1.347-.54.038-.768-.274-1.225-.898a5.2 5.2 0 0 1-.948-2.37c-.107-.799-.16-1.198-.29-1.395-.206-.313-.622-.485-.932-.667-.817-.48-1.226-.72-1.333-1.129-.108-.407.128-.823.6-1.655s.708-1.248 1.109-1.357c.4-.11.81.131 1.627.611.31.183.664.462 1.034.488.232.016.599-.137 1.332-.442a4.95 4.95 0 0 1 2.491-.35c.76.091 1.14.137 1.376.63.238.495-.01.931-.505 1.804l-.526.926m-2.002 3.53.434.254a1.984 1.984 0 0 0 2.735-.745 2.057 2.057 0 0 0-.733-2.784l-.434-.255m-2.002 3.53 2.002-3.53M7 13a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"
    />
    <path
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="m6 12 7-5"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M7 22h7M6 15l5 7"
    />
  </svg>
);
export default SvgStudyLamp;
